import React, {PropsWithChildren, useContext, useEffect, useState} from "react";
import {Activity} from "../models/activity.model";
import {getActivityAsync} from "../api/ActivityApi";
import {PreviewDataContext} from "./PreviewContext";

interface ActivityContextState {
    activity: Activity[];
    loadActivity: () => void;
    isActivityLoading: boolean;
}

export const ActivityContext = React.createContext({} as ActivityContextState);

export const ActivityProvider: React.FunctionComponent<PropsWithChildren> = ({children}) => {
    const [activity, setActivity] = useState<Activity[]>([]);
    const [isActivityLoading, setActivityLoading] = useState<boolean>(false);
    const previewContext = useContext(PreviewDataContext);

    async function loadActivity() {
        setActivityLoading(true);
        let activity = await getActivityAsync(previewContext.isPreviewMode);
        setActivity(activity);
        setActivityLoading(false);
    }

    useEffect(() => {
        if (previewContext.isPreviewInited) {
            loadActivity()
        }
    }, [previewContext.isPreviewInited]);

    return (
        <ActivityContext.Provider value={{activity, loadActivity, isActivityLoading}}>
            {children}
        </ActivityContext.Provider>
    )
}